var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroundWater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "21px",
    viewBox: "0 0 14 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "74.3135311%",
    y1: "79.2305355%",
    x2: "5.17092322%",
    y2: "16.7301648%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#451179",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196AA7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-2",
    points: "0 0 13.8846077 0 13.8846077 20.8977911 0 20.8977911"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Concepts",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.878580729
  }, /*#__PURE__*/React.createElement("g", {
    id: "Why-Past",
    transform: "translate(-446.000000, -490.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy-13",
    transform: "translate(433.000000, 481.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(13.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94531923,20.8977911 C5.70389615,20.8931392 4.49020385,20.5574051 3.42903077,19.9271392 C2.40487692,19.3182722 1.54697308,18.4504937 0.948338462,17.4173734 C0.3283,16.3526203 -2.69230769e-05,15.1316962 -2.69230769e-05,13.8880443 C-2.69230769e-05,12.8335253 0.226934615,11.819943 0.674530769,10.8756076 L0.692030769,10.8379937 C0.698088462,10.8252342 0.704415385,10.8126076 0.711011538,10.8001139 L0.920203846,10.4078924 L6.22714615,0.42664557 C6.36660769,0.164544304 6.64162692,0.000265822785 6.94168462,0 L6.94235769,0 C7.24201154,0 7.51703077,0.163746835 7.65676154,0.425449367 L12.5283577,9.54888608 C12.7363385,9.93844937 12.5851654,10.4207848 12.1904731,10.6262658 C11.7955115,10.831481 11.3073962,10.6822215 11.0992808,10.2926582 L6.94383846,2.51029747 L2.13981923,11.5472089 C1.79116538,12.2828734 1.61535769,13.0689114 1.61535769,13.8880443 C1.61535769,14.8531139 1.86924231,15.7991772 2.34955,16.6238924 C2.81249231,17.4226899 3.47358846,18.0918987 4.26203077,18.5605443 C5.07349231,19.0426139 6.00139615,19.2993987 6.94531923,19.3028544 C7.88345385,19.2993987 8.81135769,19.0426139 9.62281923,18.5605443 C10.4105885,18.0922975 11.0716846,17.4229557 11.5343577,16.6252215 C12.0153385,15.7993101 12.2692231,14.8532468 12.2692231,13.8880443 C12.2692231,13.4477089 12.6308,13.0905759 13.0769154,13.0905759 C13.5228962,13.0905759 13.8846077,13.4477089 13.8846077,13.8880443 C13.8846077,15.1318291 13.5562808,16.3527532 12.9354346,17.4189684 C12.3370692,18.4510253 11.4793,19.3186709 10.4558192,19.9270063 C9.39464615,20.5574051 8.18095385,20.8931392 6.94531923,20.8977911",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-3)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundWater);
export default __webpack_public_path__ + "static/media/ground-water.d03009a2cba922ba1995325a633d6740.svg";
export { ForwardRef as ReactComponent };